module.exports = __webpack_public_path__ + "img/role4.31979ffb.png";